<template>
  <div class="Sobre">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'sobre'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'sobre'"></homeNav>
      </div>

      <banner></banner>

      <div class="company_wrap">
        <div class="company_cont">
          <div class="company_cleft">
            <img src="../assets/image/company_banner.png" />
          </div>
          <div class="company_cright">
            <div class="company_crtitle">Introducción de empresa</div>
            <div class="company_crdesc">Para Mia es una plataforma de préstamos en efectivo en línea centrada en las necesidades de los usuarios, especializada en resolver el problema de las dificultades financieras para los usuarios mexicanos. Estamos decididos a desarrollar diferentes soluciones de préstamos de acuerdo con las diferentes necesidades de los usuarios, y proporcionar a los usuarios servicios que puedan resolver el uso de los fondos.</div>
          </div>
        </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import banner from "@/components/banner.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/sobre.scss";

export default {
    name: "Sobre",
    components: { headNav, homeNav, banner, footPage },
    data() {
      return {
        scroll: 0,
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }
  .eshoy_content_wrap{
    width: 100%;
    height: auto;
    position: relative;
    padding-top: 90px;
  }
  .company_wrap{
    width: 100%;
    height: auto;
    background: #ffffff;
  }
  .company_cont{
    width: 1200px;
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 100px 8px 98px 8px;
    display: flex;
    justify-content: space-between;
  }
  .company_cleft{
    width: 552px;
    height: 375px;
  }
  .company_cleft img{
    display: block;
    width: 552px;
    height: 375px;
  }
  .company_cright{
    width: 533px;
    height: 375px;
    box-sizing: border-box;
    padding-top: 10px;
  }
  .company_crtitle{
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    color: #006747;
    padding-bottom: 24px;
  }
  .company_crdesc{
    width: 100%;
    height: auto;
    font-size: 18px;
    font-weight: 400;
    color: #818282;
    line-height: 24px;
  }
</style>
